module.exports = __webpack_public_path__ + "assets/img/c99b9af2092589189d3da2f14038ada1.png";